import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    align-items: center;
    flex-direction: row;
    gap: 20px;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  width: 100%;

  .ant-select {
    min-width: 150px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    width: auto;
    justify-content: flex-end;
  }
`;
